import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";
import {
  wsGetVerificaEstudiosQr,
  wsPostTurnosEstudiosQr,
  logoutEstudiosTurnos,
} from "../../../context/Actions/turnos/estudioTurnos";
import {
  logoutConsultaMedTurnos,
  wsGetVerificaConsultaMedica,
  wsPostConsultaMedTurnos,
} from "../../../context/Actions/turnos/consultaMedTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";
import { IonSpinner } from "@ionic/react";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import "./BuscadorConsultaMedica.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
// import PresentismoBox from "../PresentismoBox/PresentismoBox";
// import {
//   resetPresentismo,
//   wsGetPresentismoDetalle,
// } from "_+_Portal/context/Actions/presentismo/presentismo";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";

const BuscadorConsultaMedica = ({
  onChangeMultitabMobile,
  buscadorTurnos,
  itemBusqueda,
  busquedaAuto,
}) => {
  const history = useHistory();

  const {
    estudioGrupoState,
    estudioTurnosDispatch,
    estudioTurnosState,
    modalDispatch,
    consultaMedTurnosDispatch,
    consultaMedTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    textosState,
    // presentismoDispatch,
    // presentismoState,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);

  // Información para el date picker
  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const [onChangeVc, setOnChangeVc] = useState(false);
  const [onChangePres, setOnChangePres] = useState(true);
  const [idEstudio, setIdEstudio] = useState("");
  const [descEstudio, setDescEstudio] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [medico, setMedico] = useState("");
  const [descEspecialidad, setDescEspecialidad] = useState("");
  const [fecha, setFecha] = useState();
  const [flgEstudioParticular, setFlgEstudioParticular] = useState(false);
  const [flgEspecialidadPart, setFlgEspecialidadPart] = useState(false);
  const [flgEspecialidadOk, setFlgEspecialidadOk] = useState(false);
  const [flgEstudioOk, setFlgEstudioOk] = useState(false);
  const [flgModal, setFlgModal] = useState(false);
  const [determinaciones, setDeterminaciones] = useState();
  const [dtoBusqEstudioDefault, setDtoBusqEstudioDefault] = useState();
  const [dtoPOST, setDtoPOST] = useState(false);
  const [flgDobleVerif, setDobleVerif] = useState(false);
  const [errorDropdown, setErrorDropdown] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState();
  const [user, setUser] = useState(authState);
  const [OSAlternativa, setOSAlternativa] = useState(false);

  let config = localStorage.getItem("config");
  let portalCem = JSON.parse(config).portal;
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;
  let accion = sessionStorage.getItem("accionHash");

  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // es el paciente completo
      setUser({
        auth: {
          data: selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
        },
      });
    } else {
      setUser(authState);
    }
  }, [selectDropDownState.selectDropDown.selectGlobal.pacienteElegido]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    // resetPresentismo()(presentismoDispatch);
  };

  const onChangeDatePicker = (e) => {
    setFecha(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  // Nuevo useEffect para el nuevo buscador, cuando presiono en uno de los
  // mas buscados hago la busqueda del turno directamente
  useEffect(() => {
    if (itemBusqueda !== null && itemBusqueda !== undefined) {
      onChangeBuscador(itemBusqueda);
      setFecha(fechaTurnoFormat());
    }
  }, [itemBusqueda]);

  // Este solo se ejecuta en caso de estar en la app, y seleccionar uno de los turnos
  // mas buscados, la busqueda se iniciara automaticamente
  useEffect(() => {
    if (
      itemBusqueda !== null &&
      itemBusqueda !== undefined &&
      busquedaAuto &&
      (flgEspecialidadOk || flgEstudioOk)
    ) {
      onBuscarTurnosClick(itemBusqueda);
    }
  }, [itemBusqueda, flgEspecialidadOk, flgEstudioOk]);

  const onChangeBuscador = (e) => {
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
    setPacienteSeleccionado(e);
    if (e !== "") {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingConsultas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingConsultas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <span className="rb24b">Atención</span>,
            textoNegrita: (
              <span className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </span>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        setErrorDropdown(false);
        if (e.id !== null && e.id !== undefined && e.id < 0) {
          setEspecialidad(e.especialidad);
          setMedico(e.medico);
          setDescEspecialidad(e.descripcion);
          setIdEstudio("");
          setDescEstudio("");
          // verifica si el paciente tiene esa obra social
          wsGetVerificaConsultaMedica(
            e.especialidad,
            e.medico
          )(consultaMedTurnosDispatch);
        } else if (e.id !== null && e.id !== undefined && e.id > 0) {
          setMedico("");
          setEspecialidad("");
          setDescEspecialidad("");
          setIdEstudio(e.id);
          setDescEstudio(e.descripcion);
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaEstudiosQr(
              e.id,
              flgEstudioParticular,
              onChangeVc
            )(estudioTurnosDispatch);
          } else {
            wsGetVerificaEstudiosQr(
              e.id,
              flgEstudioParticular,
              onChangeVc
            )(estudioTurnosDispatch);
          }
        }
      }
      setErrorDropdown(false);
    } else {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      setEspecialidad("");
      setMedico("");
      setDescEspecialidad("");
      setIdEstudio("");
      setDescEstudio("");
    }
  };

  // reemplace radio por check por la dificultad de marcar 1 si o no en un check
  const onChangeRadio = (e) => {
    // let usuario = Object.assign({}, registroState.registro.usuario);
    if (e.target.value === "true") {
      setOnChangePres(true);
      setOnChangeVc(false);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    } else {
      setOnChangePres(false);
      setOnChangeVc(true);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    }
  };

  useEffect(() => {
    if (flgDobleVerif) {
      if (medico !== "" && especialidad !== "" && descEspecialidad !== "") {
        setIdEstudio("");
        setDescEstudio("");
        setFlgEstudioParticular(false);
        setFlgEspecialidadOk(false);
        // verica si el paciente tiene obra social
        wsGetVerificaConsultaMedica(
          especialidad,
          medico
        )(consultaMedTurnosDispatch);
        setDobleVerif(false);
      } else if (idEstudio !== "" && descEstudio !== "") {
        setMedico("");
        setEspecialidad("");
        setDescEspecialidad("");
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificaEstudiosQr(
            idEstudio,
            flgEstudioParticular,
            onChangeVc
          )(estudioTurnosDispatch);
        } else {
          wsGetVerificaEstudiosQr(
            idEstudio,
            flgEstudioParticular,
            onChangeVc
          )(estudioTurnosDispatch);
        }
        setDobleVerif(false);
      }
    }
  }, [flgDobleVerif]);

  const onBuscarTurnosClick = (pacienteSeleccionado) => {
    if (
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.ausentismo.rankingConsultas === "Rojo"
        : authState.auth.data.paciente.ausentismo.rankingConsultas ===
          "Rojo") &&
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.seguimiento
        : !authState.auth.data.paciente.seguimiento) &&
      bloqueoPresentismo === true
    ) {
      showModal(
        "Genericos/Mensaje/Mensaje",
        {
          titulo: <span className="rb24b">Atención</span>,
          textoNegrita: (
            <span className="rb18l">
              {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
            </span>
          ),
          dissmiss: dissmiss,
        },
        [
          {
            text: "Cerrar",
            clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
            accion: dissmiss,
          },
        ],
        "centro",
        true
      )(modalDispatch);
    } else {
      // CAMBIE EL IF QUE NO DEJABA BUSCAR POR ESPECIALIDAD, YA ARROJA ERROR SI EL CAMPO ESTA VACIO
      if (pacienteSeleccionado !== "" && pacienteSeleccionado !== undefined) {
        if (!flgModal) {
          // funcion para obtener la fecha formateada en caso de necesitarla para la busqueda
          if (flgEspecialidadOk) {
            setDtoPOST({
              especialidad: especialidad,
              medico: medico,
              fecha: fecha,
              flgEspecialidadPart: flgEspecialidadPart,
              videoConsulta: onChangeVc,
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            });
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id
              )(consultaMedTurnosDispatch);
            } else {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                -1,
                OSAlternativa ? OSAlternativa : false
              )(consultaMedTurnosDispatch);
            }
            setFlgEspecialidadOk(false);
          } else if (flgEstudioOk) {
            setDtoBusqEstudioDefault({
              ...dtoBusqEstudioDefault,
              amamantando: false,
              conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
              contrasteReciente: false,
              diabeticoHipertenso: false,
              embarazada: false,
              fechaDesde: fecha, //fecha esta en datepicker,
              GruposMedico: [
                {
                  Id: idEstudio,
                  Descripcion: descEstudio,
                  Particular: flgEstudioParticular,
                },
              ],
              idGrupoMedico: idEstudio, //lo obtengo de seleccionar el item especialidad o estudio
              idObraSocial: selectDropDownState.selectDropDown.selectGlobal
                .pacienteElegido
                ? selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.obra_social
                : user.auth.data.paciente.obra_social,
              idPlan: selectDropDownState.selectDropDown.selectGlobal
                .pacienteElegido
                ? selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.idplan
                : user.auth.data.paciente.idplan,
              insRenal: false,
              marcapasos: false,
              operador: accion ? "BOT" : "",
              pag: 1200, //hardcodeado en angular
              particular: flgEstudioParticular, //lo obtengo de seleccionar el check
              pesoSuperior: false,
              pesoSuperiorCritico: false,
              rec: 0, //harcodeado en angularionic
              videoAtencion: onChangeVc, //lo lleno por con el checkbox
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            });
          }
        } else {
          // le consulto nuevamente si lo quiere tomar como part.
          if (flgEspecialidadOk) {
            wsGetVerificaConsultaMedica(
              especialidad,
              medico
            )(consultaMedTurnosDispatch);
          } else if (flgEstudioOk) {
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaEstudiosQr(
                idEstudio,
                false,
                false
              )(estudioTurnosDispatch);
            } else {
              wsGetVerificaEstudiosQr(
                idEstudio,
                false,
                false
              )(estudioTurnosDispatch);
            }
          }
        }
      } else {
        setErrorDropdown(true);
      }
    }
  };

  //agrego lo de cambio de fecha en consulta medica.
  const verificaCambioFecha = () => {
    let objBusqDefault = Object.assign({}, dtoBusqEstudioDefault);
    if (fecha !== null) {
      objBusqDefault.fechaDesde = fecha;
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
    ) {
      objBusqDefault.fechaDesde =
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
    }
    return objBusqDefault;
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    setFlgEspecialidadPart(false);
    setFlgEstudioParticular(false);
    // setFlgEstudioOk(false);
    // setFlgEspecialidadOk(false);
    // setFlgModal(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    setOSAlternativa(false);
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
  };

  const deterComoParticular = () => {
    dissmiss();
    setFlgModal(false);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  };

  const modalParticular = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno como particular?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  useEffect(() => {
    if (dtoBusqEstudioDefault !== undefined) {
      let objBusqueda = verificaCambioFecha();
      setDtoPOST(objBusqueda);
      wsPostTurnosEstudiosQr(objBusqueda)(estudioTurnosDispatch);
      setDtoBusqEstudioDefault(undefined);
      //por ahora part no
      // setFlgParticular(false);
    }
  }, [dtoBusqEstudioDefault]);

  useEffect(() => {
    if (
      estudioTurnosState.estudioTurnos.data !== undefined &&
      estudioTurnosState.estudioTurnos.data !== null &&
      estudioTurnosState.estudioTurnos.data !== false &&
      estudioTurnosState.estudioTurnos.data !== ""
    ) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === ""
      ) {
        setFlgEstudioOk(true);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (
        estudioTurnosState.estudioTurnos.data.turnos !== null &&
        estudioTurnosState.estudioTurnos.data.turnos !== undefined &&
        estudioTurnosState.estudioTurnos.data.turnos !== ""
      ) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: estudioTurnosState.estudioTurnos.data.turnos,
          GruposMedico: [
            {
              Id: idEstudio,
              Descripcion: descEstudio,
              Particular: flgEstudioParticular,
            },
          ],
          particular: flgEstudioParticular,
          idEstudio: idEstudio,
          descEstudio: descEstudio,
          descEspecialidad: null,
          fechaBusqueda: estudioTurnosState.estudioTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "estudios",
        })(turnosDisponiblesDispatch);
        setFlgEstudioParticular(false);
        history.push("/turnosDisponibles");
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 9) {
        setFlgEstudioParticular(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalParticular();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 8) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Atención",
            texto: (
              <div
                dangerouslySetInnerHTML={{
                  __html: estudioTurnosState.estudioTurnos.data.mensaje,
                }}
              ></div>
            ),
            dissmiss: dissmiss,
            danger: true,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: cancelaParticular,
            },
          ],
          "centro"
        )(modalDispatch);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 91) {
        setOSAlternativa(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalOSAlternativa();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 10) {
        modalAtencionSinTurnoPrevio();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.data.codigo) {
        showToaster(
          {
            texto: estudioTurnosState.estudioTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      }
    } else if (
      estudioTurnosState.estudioTurnos.error !== null &&
      estudioTurnosState.estudioTurnos.error !== undefined &&
      estudioTurnosState.estudioTurnos.error !== false
    ) {
      if (estudioTurnosState.estudioTurnos.error.detail === "9") {
        setFlgEstudioParticular(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalParticular();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.error.detail === "8") {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Atención",
            texto: (
              <div
                dangerouslySetInnerHTML={{
                  __html: estudioTurnosState.estudioTurnos.error.detail,
                }}
              ></div>
            ),
            dissmiss: dissmiss,
            danger: true,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: cancelaParticular,
            },
          ],
          "centro"
        )(modalDispatch);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.error.detail === "91") {
        setOSAlternativa(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalOSAlternativa();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (estudioTurnosState.estudioTurnos.error.detail === "10") {
        modalAtencionSinTurnoPrevio();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else if (
        estudioTurnosState.estudioTurnos.error.detail === "" ||
        estudioTurnosState.estudioTurnos.error.detail === null ||
        estudioTurnosState.estudioTurnos.error.detail === undefined
      ) {
        showToaster(
          {
            texto: "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        if (
          estudioTurnosState.estudioTurnos.error.detail !== "" &&
          estudioTurnosState.estudioTurnos.error.detail !== null &&
          estudioTurnosState.estudioTurnos.error.detail !== undefined
        ) {
          if (estudioTurnosState.estudioTurnos.error.detail.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: estudioTurnosState.estudioTurnos.error.detail,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro"
            )(modalDispatch);
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else {
            showToaster(
              {
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: estudioTurnosState.estudioTurnos.error.detail,
                    }}
                  ></div>
                ),
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: estudioTurnosState.estudioTurnos.error,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      }
    }
  }, [estudioTurnosState]);

  useEffect(() => {
    if (
      consultaMedTurnosState.consultaMedTurnos.data !== undefined &&
      consultaMedTurnosState.consultaMedTurnos.data !== null &&
      consultaMedTurnosState.consultaMedTurnos.data !== false &&
      consultaMedTurnosState.consultaMedTurnos.data !== ""
    ) {
      if (
        consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 0
      ) {
        setFlgEspecialidadOk(true);
        setFlgEstudioOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 1
      ) {
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        setFlgEspecialidadOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 3
      ) {
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        setFlgEspecialidadOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 5
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 6
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 7
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 8
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 9
      ) {
        setFlgEspecialidadPart(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalParticular();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 91
      ) {
        setOSAlternativa(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalOSAlternativa();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.data.data.length >= 0
      ) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: consultaMedTurnosState.consultaMedTurnos.data.data,
          grupoMedico: null,
          particular: flgEspecialidadPart,
          idEstudio: null,
          descEstudio: null,
          descEspecialidad: descEspecialidad,
          fechaBusqueda:
            consultaMedTurnosState.consultaMedTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "consMedica",
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponibles");
      }
    } else if (
      consultaMedTurnosState.consultaMedTurnos.error !== null &&
      consultaMedTurnosState.consultaMedTurnos.error !== undefined &&
      consultaMedTurnosState.consultaMedTurnos.error !== false
    ) {
      if (consultaMedTurnosState.consultaMedTurnos.error.detail === "9") {
        setFlgEspecialidadPart(true);
        modalParticular();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.error.detail === "10"
      ) {
        modalAtencionSinTurnoPrevio();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.error.detail === "91"
      ) {
        modalOSAlternativa();
        setOSAlternativa(true);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
      } else {
        if (
          consultaMedTurnosState.consultaMedTurnos.error.detail !== "" &&
          consultaMedTurnosState.consultaMedTurnos.error.detail !== null &&
          consultaMedTurnosState.consultaMedTurnos.error.detail !== undefined
        ) {
          if (
            consultaMedTurnosState.consultaMedTurnos.error.detail.length > 100
          ) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Requiere autorización",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        consultaMedTurnosState.consultaMedTurnos.error.detail,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro"
            )(modalDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
          } else {
            showToaster(
              {
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        consultaMedTurnosState.consultaMedTurnos.error.detail,
                    }}
                  ></div>
                ),
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: consultaMedTurnosState.consultaMedTurnos.error,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
        }
      }
    }
  }, [consultaMedTurnosState]);

  //agrego logica volver a verificar estudio/consMed por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      if (especialidad !== "" && medico) {
        wsGetVerificaConsultaMedica(
          especialidad,
          medico,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
        )(consultaMedTurnosDispatch);
      } else if (idEstudio !== "" && descEstudio !== "") {
        wsGetVerificaEstudiosQr(
          idEstudio,
          flgEstudioParticular,
          onChangeVc
        )(estudioTurnosDispatch);
      }
    } else {
      if (
        (especialidad !== "" && medico !== "") ||
        (idEstudio !== "" && descEstudio !== "")
      ) {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        if (especialidad !== "" && medico !== "") {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico
          )(consultaMedTurnosDispatch);
        } else if (idEstudio !== "" && descEstudio !== "") {
          wsGetVerificaEstudiosQr(
            idEstudio,
            flgEstudioParticular,
            onChangeVc
          )(estudioTurnosDispatch);
        }
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) =>
          item.sonpracticas === false &&
          item.idcircuito !== "RMN" &&
          item.idcircuito !== "TOMO"
      );
      const grupoMed = arrGrupoMed.filter((item) => item.id > 0);
      const agenda = arrGrupoMed.filter((item) => item.id < 0);
      const turnosCompletos = grupoMed.concat(agenda);
      let filt = turnosCompletos.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setDeterminaciones(filt);
      setFecha(fechaTurnoFormat());
    }
    //me aseguro que siempre se limpien los turnos disponibles
    // finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const modalTurnosPresentismo = () => {
    // if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
    //   wsGetPresentismoDetalle(
    //     true,
    //     selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
    //   )(presentismoDispatch);
    // } else {
    //   wsGetPresentismoDetalle(true, false)(presentismoDispatch);
    // }
  };

  // useEffect(() => {
  //   if (presentismoState.presentismo.data !== null) {
  //     showModal(
  //       "Turnos/ModalPresentismo/ModalPresentismo",
  //       {
  //         dissmiss: dissmiss,
  //         danger: true,
  //       },
  //       [],
  //       "centro",
  //       true
  //     )(modalDispatch);
  //   }
  // }, [presentismoState.presentismo.data]);

  const modalInfoPresentismo = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: <span className="rb24b">Información</span>,
        textoNegrita: (
          <span
            className="rb18l explicacionPresentismo"
            dangerouslySetInnerHTML={{
              __html:
                textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
            }}
          ></span>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Aceptar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: dissmiss,
        },
      ],
      "centro",
      true
    )(modalDispatch);
  };
  const [test, setTest] = useState(1);

  const configDropdown = {
    data: determinaciones,
    ordenPersonalizado: true,
    autoFocus: true,
    header: buscadorTurnos ? "" : "Busca por especialidad o profesional",
    headerColor: buscadorTurnos && "c-white",
    footer: "Busca una especialidad o profesional",
    descripcion: "descripcion",
    placeholder: textosState.textos.data?.txtConsultaMedica?.descripcion,
    placeHolderFontSize: 16,
    defaultValue:
      itemBusqueda !== null && itemBusqueda !== undefined
        ? itemBusqueda.descripcion
        : test,
    defaultValueParametro: "descripcion",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: false,
    arrow: true,
    search: true,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
    masBuscados: true,
    itemBusqueda: itemBusqueda,
    buscarPorDefault: true,
  };

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <>
          <div className="ptur-buscadorConsulta-desktop-dropdown">
            <Dropdown
              valor={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? ""
                  : selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                  ? selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.id
                  : authState.auth.data.paciente.codigo
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos"
              )}
              campoCodigo="id"
              descripcion="nombre"
              onChange={onChangeMultitabMobile}
              placeholder={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? "Cargando Familiares..."
                  : ""
              }
              desactivado={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? true
                  : false
              }
              heightLista={"auto"}
              customCss={"widthDropdownBuscador"}
            />
            {/* <PresentismoBox
              consultas={true}
              modalInfoPresentismo={modalInfoPresentismo}
              modalTurnosPresentismo={modalTurnosPresentismo}
            /> */}
          </div>

          {/* <div className="ptur-buscadorConsulta-presentismoMobile">
            <PresentismoBox
              consultas={true}
              modalInfoPresentismo={modalInfoPresentismo}
              modalTurnosPresentismo={modalTurnosPresentismo}
            />
          </div> */}
        </>
      )}

      <div
        className={
          !buscadorTurnos
            ? "cuerpoPestaniaConsulta"
            : "cuerpoPestaniaConsultaBuscadorTurnos"
        }
      >
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorConsultaTurnos-dropdown"
              : "ptur-buscadorConsulta-dropdown"
          }
        >
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div className="ptur-buscadorConsultaMedica-checkbox-boton">
          <div className="ptur-buscadorConsultaMedica-checkbox-container">
            {portalCem === "cemedic" ? (
              <div className="ptur-buscador-checkbox-consultaMedica-general">
                <div className="ptur-buscador-checkbox-consultaMedica">
                  <InputV1
                    inputType="hidden"
                    labelStr="Presencial"
                    labelColor={buscadorTurnos && "c-white"}
                    nombreRadio="formato"
                    name="checkpresencial"
                    onChange={onChangeRadio}
                    value={true}
                    checked
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="ptur-buscador-titulo-checkbox-consultaMedica">
                  <span className={`${buscadorTurnos && "c-white"} rb14m`}>
                    Formato
                  </span>
                </div>
                <div className="ptur-buscador-checkbox-consultaMedica-general">
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Presencial"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkpresencial"
                      onChange={onChangeRadio}
                      value={true}
                      checked
                    />
                  </div>
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Video llamada"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkvideollamada"
                      onChange={onChangeRadio}
                      value={false}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="ptur-buscadorConsulta-boton-fecha">
            <div className="ptur-buscadorConsulta-fecha">
              <DatePicker
                fechaInicial={`${hoyDia.getFullYear()} ${
                  hoyDia.getMonth() + 1
                } ${hoyDia.getDate()}`}
                fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                  noventaDiasDespues.getMonth() + 1
                } ${noventaDiasDespues.getDate()}`}
                headerStr={"Buscar fecha"}
                headerStrColor={buscadorTurnos && "c-white"}
                // fechaMin={hoy}
                onChange={onChangeDatePicker}
                customCss="ptur-datePciker-consultaMedica"
              />
            </div>
            <div className="ptur-buscadorConsulta-boton-container">
              <button
                onClick={() => onBuscarTurnosClick(pacienteSeleccionado)}
                className={`ptur-consulta-botonSiguiente bgc-primary c-white rb18m`}
                disabled={
                  estudioTurnosState.estudioTurnos.loading ||
                  consultaMedTurnosState.consultaMedTurnos.loading
                }
              >
                {estudioTurnosState.estudioTurnos.loading ||
                consultaMedTurnosState.consultaMedTurnos.loading ? (
                  <span className="ptur-buscadorConsulta-loading">
                    <IonSpinner name="lines-small" />
                  </span>
                ) : (
                  "Siguiente"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BuscadorConsultaMedica;
